function resolveTimeZone(timeZone?: string | null) {
  const trimmed = timeZone?.trim();
  return trimmed ? trimmed : undefined;
}

function yearInTimeZone(date: Date, timeZone?: string) {
  const resolved = resolveTimeZone(timeZone);
  if (!resolved) {
    return date.getFullYear();
  }

  return Number(
    new Intl.DateTimeFormat('en-US', {
      timeZone: resolved,
      year: 'numeric',
    }).format(date),
  );
}

export function formatSessionDate(dateString: string | null, timeZone?: string | null) {
  if (!dateString) {
    return 'Recent session';
  }

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return 'Recent session';
  }

  const resolvedTimeZone = resolveTimeZone(timeZone);
  const includeYear = yearInTimeZone(date, resolvedTimeZone) !== yearInTimeZone(new Date(), resolvedTimeZone);

  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    ...(includeYear ? { year: 'numeric' as const } : {}),
    hour: 'numeric',
    minute: '2-digit',
    ...(resolvedTimeZone ? { timeZone: resolvedTimeZone } : {}),
  });
}

export function formatSessionDateOnly(dateString: string | null, timeZone?: string | null) {
  if (!dateString) {
    return 'Recent session';
  }

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return 'Recent session';
  }

  const resolvedTimeZone = resolveTimeZone(timeZone);
  const includeYear = yearInTimeZone(date, resolvedTimeZone) !== yearInTimeZone(new Date(), resolvedTimeZone);

  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    ...(includeYear ? { year: 'numeric' as const } : {}),
    ...(resolvedTimeZone ? { timeZone: resolvedTimeZone } : {}),
  });
}

export function formatSessionTime(dateString: string | null, timeZone?: string | null) {
  if (!dateString) {
    return null;
  }

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const resolvedTimeZone = resolveTimeZone(timeZone);

  return date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
    ...(resolvedTimeZone ? { timeZone: resolvedTimeZone } : {}),
  });
}

export function formatRecordedAtMs(
  recordedAtMs: number,
  timeZone?: string | null,
  style: 'date' | 'time' | 'datetime' = 'datetime',
) {
  const date = new Date(recordedAtMs);
  if (Number.isNaN(date.getTime())) {
    return style === 'time' ? null : 'Recent session';
  }

  const resolvedTimeZone = resolveTimeZone(timeZone);
  const includeYear = yearInTimeZone(date, resolvedTimeZone) !== yearInTimeZone(new Date(), resolvedTimeZone);
  const timeZoneOption = resolvedTimeZone ? { timeZone: resolvedTimeZone } : {};

  if (style === 'date') {
    return date.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
      ...(includeYear ? { year: 'numeric' as const } : {}),
      ...timeZoneOption,
    });
  }

  if (style === 'time') {
    return date.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      ...timeZoneOption,
    });
  }

  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    ...(includeYear ? { year: 'numeric' as const } : {}),
    hour: 'numeric',
    minute: '2-digit',
    ...timeZoneOption,
  });
}
